<span class="description">
  {{ nameKey | translate }}
</span>
<automata-crm-created-modified *ngIf="isCRMRecordChangeTrigger" [(value)]="action"></automata-crm-created-modified>
<ng-container *ngIf="action !== comparison.Created && isCRMRecordChangeTrigger">
  <automata-automation-replacement-chips
    [label]="labelDisplay"
    [dataService]="crmFieldsSelectorService"
    [formControl]="formControl"
    [isRequired]="true"
    [multiple]="true"
    [supportDataPassing]="false"
    [extraData]="{
      supportedFieldTypes: supportedFieldTypes,
      crmObjectType: crmSubType,
      filterToOnlyStandardFields: onlyStandardFields,
    }"
  ></automata-automation-replacement-chips>
  <div class="description">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CREATED_MODIFIED.DESCRIPTION' | translate }}
  </div>
</ng-container>
